export const applyPagination = (subList, page, limit) => {
  return subList.slice(page * limit, page * limit + limit);
};
